export default __webpack_public_path__ + "static/media/waspnest2.13a6b4ba.png";